import styles from './Clientes.module.css';
import CarruselLogos from '../../UI/CarruselLogos';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import clientes from '../../../datos/clientes.json';

const SeccionClientes = () => {
  const [seccionRef, esVisible] = useScrollAnimation({ threshold: 0.05 });

  const mitad = Math.ceil(clientes.length / 2);
  const filaUno = clientes.slice(0, mitad);
  const filaDos = clientes.slice(mitad);

  return (
    <section
      id="clientes"
      ref={seccionRef}
      className={`${styles.seccion} ${esVisible ? styles.visible : ''}`}
    >
      <div className={styles.encabezado}>
        <h2 className={styles.titulo}>Nuestros <span className={styles.acento}>Clientes</span></h2>
        <div className={`${styles.lineaTitulo} ${esVisible ? styles.lineaVisible : ''}`} />
        <p className={styles.subtitulo}>
          Empresas líderes de Guatemala y Centroamérica confían en SEIMA para sus soluciones de limpieza industrial.
        </p>
      </div>
      <div className={styles.filas}>
        <CarruselLogos items={filaUno} carpeta="clientes" velocidad={0.5} direccion={1} />
        <CarruselLogos items={filaDos} carpeta="clientes" velocidad={0.5} direccion={-1} />
      </div>
    </section>
  );
};

export default SeccionClientes;
